import { render, staticRenderFns } from "./RoomTypeForm.vue?vue&type=template&id=362cbf5e&scoped=true"
import script from "./RoomTypeForm.vue?vue&type=script&lang=js"
export * from "./RoomTypeForm.vue?vue&type=script&lang=js"
import style0 from "./RoomTypeForm.vue?vue&type=style&index=0&id=362cbf5e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "362cbf5e",
  null
  
)

export default component.exports